export const textPlainDataType = 'text/plain';
